export const FETCH_TERMINAL_LOGS_LOADING = "FETCH_TERMINAL_LOGS_LOADING";
export const FETCH_TERMINAL_LOGS_SUCCESS = "FETCH_TERMINAL_LOGS_SUCCESS";
export const FETCH_TERMINAL_LOGS_FAILED = "FETCH_TERMINAL_LOGS_FAILED";
export const CLEAR_TERMINAL_LOGS = "CLEAR_TERMINAL_LOGS;";
